var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading && !_vm.isPlpExclusive
    ? _c("rb-dummy-skeleton", {
        staticClass: "rb-product-tile__image --image-skeleton",
        attrs: { icon: "assets" },
      })
    : (_vm.isMobile && !_vm.isProductTileEditorial) || _vm.isPlpExclusive
    ? _c("rb-product-tile-images-carousel", {
        attrs: {
          variants: _vm.swiperImages,
          "is-transition": _vm.isTransitionImage,
          "transition-image": _vm.transitionImageSrc,
          "show-hover-image": _vm.showHoverImage,
          "first-hover": _vm.firstHover,
          "is-first-transition-in-viewport": _vm.isFirstTransitionInViewport,
          "is-worn-image": _vm.wornImage,
          "is-inside-search-panel": _vm.isInsideSearchPanel,
          "selected-variant-index": _vm.selectedIndex,
        },
        on: { "update:change-variant": _vm.selectIndex },
      })
    : _c(
        "div",
        { staticClass: "rb-product-tile__image" },
        [
          _vm.selectedIndex === 0 && _vm.isTransitionImage
            ? [
                _vm.showHoverImage || _vm.isFirstShow
                  ? _c("rb-lazy-media", {
                      staticClass: "rb-product-tile__image-lazy --hover-image",
                      class: {
                        "--has-hover": _vm.showHoverImage,
                        "--is-transition-images": _vm.isTransitionImage,
                      },
                      attrs: {
                        src: _vm.transitionImageSrc,
                        alt: _vm.altImage,
                        "no-pointer-event-image": true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "custom-element-image",
                            fn: function () {
                              return [
                                _c("rb-dummy-skeleton", {
                                  staticClass: "--image-loading",
                                  attrs: { icon: "assets" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3718722899
                      ),
                    })
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.showHoverImage || _vm.isFirstShow
            ? _c("rb-lazy-media", {
                staticClass: "rb-product-tile__image-lazy --hover-image",
                class: { "--has-hover": _vm.showHoverImage },
                attrs: {
                  src: _vm.hoverImage,
                  alt: _vm.altImage,
                  "no-pointer-event-image": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "custom-element-image",
                      fn: function () {
                        return [
                          _c("rb-dummy-skeleton", {
                            staticClass: "--image-loading",
                            attrs: { icon: "assets" },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3718722899
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("rb-lazy-media", {
            staticClass: "rb-product-tile__image-lazy --main-image",
            class: { "--has-sibling-hover": _vm.showHoverImage },
            attrs: {
              src: _vm.mainImage,
              alt: _vm.altImage,
              "force-load": _vm.preventLazy,
              "no-pointer-event-image": true,
            },
            scopedSlots: _vm._u([
              {
                key: "custom-element-image",
                fn: function () {
                  return [
                    _c("rb-dummy-skeleton", {
                      staticClass: "--image-loading",
                      attrs: { icon: "assets" },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }